import { TFunction } from "i18next";

import { EventTypeCellParts, EventTypeStrategy } from "./EventTypeStrategy";
import { getTranslatedEventTypeName } from "../../utils/eventTypeUtils";

import { TransactionType } from "@/types/transaction/TransactionType";

export class CampaignBudgetRemovedEventTypeStrategy
implements EventTypeStrategy
{
  renderCell(row: TransactionType, t: TFunction): JSX.Element {
    const fromText = row.eventData.campaignName ? (
      <>
        {" "}
        {t("from")} <b>{row.eventData.campaignName}</b>
      </>
    ) : (
      ""
    );
    const onText = row.eventData.jobBoardName ? (
      <>
        {" "}
        {t("on")} <b>{row.eventData.jobBoardName}</b>
      </>
    ) : (
      ""
    );
    const inText = row.eventData.month ? (
      <>
        {" "}
        {t("in")}{" "}
        <b>
          {new Date(row.eventData.month).toLocaleDateString("en-US", {
            month: "long",
            year: "numeric",
          })}
        </b>
      </>
    ) : (
      ""
    );

    return (
      <>
        {t(`eventTypes.${row.eventType}`)}
        {fromText}
        {onText}
        {inText}
      </>
    );
  }

  getTypeAndDescription(
    row: TransactionType,
    t: TFunction
  ): EventTypeCellParts {
    const fromText = row.eventData.campaignName ? (
      <>
        {" "}
        {t("from")} <b>{row.eventData.campaignName}</b>
      </>
    ) : (
      ""
    );
    const onText = row.eventData.jobBoardName ? (
      <>
        {" "}
        {t("on")} <b>{row.eventData.jobBoardName}</b>
      </>
    ) : (
      ""
    );
    const inText = row.eventData.month ? (
      <>
        {" "}
        {t("in")}{" "}
        <b>
          {new Date(row.eventData.month).toLocaleDateString("en-US", {
            month: "long",
            year: "numeric",
          })}
        </b>
      </>
    ) : (
      ""
    );

    return {
      type: <>{getTranslatedEventTypeName(row.eventType, t)}</>,
      description: (
        <>
          {fromText}
          {onText}
          {inText}
        </>
      ),
    };
  }
}
